import React from "react";
import Overview from "./Overview";

import { PaymentProvider } from "../../context/PaymentContext";

export const Payment = () => {
  return (
    <PaymentProvider>
      <Overview />
    </PaymentProvider>
  );
};
